import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { OrgContextService } from '../core/services/org-context.service';

export function requirePermission(permission: string, fallbackUrl = '/account'): CanActivateFn {
  return async () => {
    const orgContext = inject(OrgContextService);
    const router = inject(Router);

    if (!orgContext.currentOrg()) {
      return router.parseUrl('/account');
    }

    const hasPermission = await orgContext.checkPermission(permission);
    return hasPermission || router.parseUrl(fallbackUrl);
  };
}

export function requireOrg(): CanActivateFn {
  return async () => {
    const orgContext = inject(OrgContextService);
    const router = inject(Router);

    const org = orgContext.currentOrg();
    return org ? true : router.parseUrl('/account');
  };
}
